import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  createUser,
  deleteUser,
  getNext,
  getParticularPage,
  getPrevious,
  getUser,
  handleSearch,
} from "./thunk";

const initialState = {
  users: [],
  edit: false,
  user: null,
  count: null,
  next: null,
  previous: null,
  loading: false,
  loadingUser: false,
  loadingUpdated: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    // createUser cases
    builder
      .addCase(createUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(createUser.fulfilled, (state, action) => {
        state.loading = false;
        state.edit = false;

        const newUser = action.payload.data;
        if (newUser) {
          state.users = [newUser, ...state.users];
        } else {
          console.error("New user data is invalid:", action.payload);
        }
      })
      .addCase(createUser.rejected, (state) => {
        state.loading = false;
        state.edit = false;
      })

      // deleteUser cases
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.loading = false;
        state.edit = false;
        const deletedUserId = action.meta.arg;
        state.users = state.users.filter((user) => user.id !== deletedUserId);
      })
      .addCase(deleteUser.rejected, (state) => {
        state.loading = false;
        state.edit = false;
      })

      // getUser cases
      .addMatcher(isAnyOf(getUser.pending, handleSearch.pending), (state) => {
        state.loadingUser = true;
      })
      .addMatcher(
        isAnyOf(
          getUser.fulfilled,
          handleSearch.fulfilled,
          getParticularPage.fulfilled,
          getPrevious.fulfilled,
          getNext.fulfilled
        ),
        (state, action) => {
          state.loadingUser = false;
          state.users = action.payload.results;
          state.count = action.payload.count;
          state.previous = action.payload.previous;
          state.next = action.payload.next;
        }
      )
      .addMatcher(isAnyOf(getUser.rejected, handleSearch.rejected), (state) => {
        state.loadingUser = false;
      });
  },
});

export const { userEditSuccess, clearEditUser } = userSlice.actions;

export default userSlice.reducer;
